export const download = (data, contentType, filename) => {
  if (contentType === 'application/json' && typeof data !== 'string') {
    data = JSON.stringify(data);
  }
  
  const a = document.createElement('a');
  const blob = new Blob([data], { type: contentType });
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  a.remove();
};
